import { Directive, ElementRef, HostListener, Input, OnInit, booleanAttribute } from '@angular/core';

@Directive({
  selector: 'input[aprovaInputSecurity]',
  standalone: true,
})
export class InputSecurityDirective implements OnInit {
  private enabled: boolean = false;
  private originalName: string | null = null;
  private originalAutocomplete: string | null = null;

  @Input({ transform: booleanAttribute })
  set aprovaInputSecurity(value: boolean) {
    this.enabled = value;
    this.updateAttributes();
  }

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {
    // noop
  }

  ngOnInit(): void {
    this.updateAttributes();
  }

  private updateAttributes(): void {
    const el = this.elementRef.nativeElement;
    if (this.enabled) {
      if (this.originalName === null) {
        this.originalName = el.getAttribute('name');
      }
      if (this.originalAutocomplete === null) {
        this.originalAutocomplete = el.getAttribute('autocomplete');
      }

      el.setAttribute('name', this.generateRandomName());
      el.setAttribute('autocomplete', 'new-password');
      el.setAttribute('autocapitalize', 'off');
      el.setAttribute('autocorrect', 'off');
      el.setAttribute('spellcheck', 'false');
      el.setAttribute('aria-autocomplete', 'none');
      el.setAttribute('data-lpignore', 'true');
    } else {
      if (this.originalName !== null) {
        if (this.originalName) {
          el.setAttribute('name', this.originalName);
        } else {
          el.removeAttribute('name');
        }
        this.originalName = null;
      }

      if (this.originalAutocomplete !== null) {
        if (this.originalAutocomplete) {
          el.setAttribute('autocomplete', this.originalAutocomplete);
        } else {
          el.removeAttribute('autocomplete');
        }
        this.originalAutocomplete = null;
      } else {
        el.removeAttribute('autocomplete');
      }
      el.removeAttribute('autocapitalize');
      el.removeAttribute('autocorrect');
      el.removeAttribute('spellcheck');
      el.removeAttribute('aria-autocomplete');
      el.removeAttribute('data-lpignore');
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (this.enabled) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    if (this.enabled) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (!this.enabled) return;
    if ((event.ctrlKey || event.metaKey) && (event.key === 'v' || event.key === 'V')) {
      event.preventDefault();
    }
  }

  private generateRandomName(): string {
    const random = Math.random().toString(36).slice(2);
    const time = Date.now().toString(36);
    return `aprova-input-sec-${time}-${random}`;
  }
}
